import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FwcAlert, FwcTooltip } from '../../../../fwc-lib.js';
import { DetailsService } from 'src/app/pages/secure/account/details/details.service';
import { NewEnrollmentService } from 'src/app/pages/secure/new-enrollment/new-enrollment.service';
import { AppConstants } from '../../constants/app-constants';
import { ConfigDataService } from '../../services/config-data.service';
import { UserCacheService } from '../../services/user-cache.service';
declare var ProtectPANandCVV;
declare var PIE;
@Component({
    selector: 'app-payment-information',
    templateUrl: './payment-information.component.html',
    styleUrls: ['./payment-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PaymentInformationComponent implements OnInit {
    @Input() content: any;
    @Input() selectCoverage: any;
    @Input() aboutYou: any;
    @Input() dependents: any;
    @Input() isMyAccount: boolean;
    @Input() isMyAccountEnrol: boolean;
    paymentInformationAgreement: any;
    public paymentInformationForm: UntypedFormGroup;
    public formSubmitted = false;
    public sameAddress: any;
    public totalCharge: any;
    public daysDifference: any;
    public monthsDifference: any;
    public cardDetails = {
        keyId: '',
        phaseId: '',
        ccno: '',
        integrityCheck: ''
    };
    statesData = [];
    fromDate: any;
    toDate: any;
    paymentTypes = [];
    months = [];
    currentYear = [];
    isPaymentFormValid = false;
    studentData: any;
    paymentInfo: any;
    constructor(
        private formBuilder: UntypedFormBuilder,
        public userCacheService: UserCacheService,
        private configDataService: ConfigDataService,
        private detailsService: DetailsService,
        private enrollmentService: NewEnrollmentService
    ) {
        const fwcTooltip = new FwcTooltip();
        fwcTooltip.build();
        const fwcAlert = new FwcAlert();
        fwcAlert.build();
    }

    ngOnInit(): void {
        this.paymentInformationForm = this.formBuilder.group({
            paymentType: ['', Validators.required],
            nameOnCard: ['', Validators.required],
            cardNumber: ['', [Validators.required, this.cardNumberValidator.bind(this)]],
            middleInitial: ['', Validators.required],
            expirationMonth: ['', Validators.required],
            expirationYear: ['', Validators.required],
            billingAddress: ['', Validators.required],
            suite_apt: [''],
            billingCity: ['', Validators.required],
            billingState: ['', Validators.required],
            billingZipCode: ['', Validators.required],
            fullName: ['', Validators.required],
            bankName: ['', Validators.required],
            routingNumber: ['', Validators.required],
            accountNumber: ['', Validators.required],
        });
        if (this.selectCoverage && this.selectCoverage.Rates) {
            this.selectCoverage.Rates.forEach(element => {
                if (element.for === 'Total') {
                    this.totalCharge = element.rate;
                }
            });
        }

        if (this.selectCoverage) {
            this.calculateDateDiff();
        }
        this.getUserDetails();
        this.createYearArray();
    }

    get form(): { [p: string]: AbstractControl } { return this.paymentInformationForm.controls; }

    calculateDateDiff(): void {
        // to convert string into Date format
        // function parseDate(str): any {
        //     const mdy = str.split('/');
        //     return new Date(mdy[2], mdy[0] - 1, mdy[1]);
        // }
        // function monthDiff(d1, d2): void {
        //     let months;
        //     months = (d2.getFullYear() - d1.getFullYear()) * 12;
        //     months -= d1.getMonth();
        //     months += d2.getMonth();
        //     return months <= 0 ? 0 : months;
        // }
        // function datediff(first, second): number {
        //     return Math.round((second - first) / (1000 * 60 * 60 * 24));
        // }
        this.fromDate = this.selectCoverage.paymentFrequency === 'once' ? this.selectCoverage.coverageStart : this.selectCoverage.startDate;
        this.toDate = this.selectCoverage.paymentFrequency === 'once' ? this.selectCoverage.coverageEnd : this.selectCoverage.endDate;
        // not needed to show
        // this.daysDifference = datediff(parseDate(this.fromDate), parseDate(this.toDate));
        // this.monthsDifference = monthDiff(parseDate(this.fromDate), parseDate(this.toDate));
    }

    onSubmitForm(): void {
        this.formSubmitted = true;
        this.isPaymentFormValid = false;
        const paymentType = this.paymentInformationForm.get('paymentType').value;
        if ((paymentType === 'VISA' || paymentType === 'MASTERCARD' || paymentType === 'DISCOVERNETWORK') && paymentType !== '') {
            if (this.paymentInformationForm.get('billingAddress').valid &&
                this.paymentInformationForm.get('billingCity').valid &&
                this.paymentInformationForm.get('billingState').valid &&
                this.paymentInformationForm.get('billingZipCode').valid &&
                this.paymentInformationForm.get('nameOnCard').valid &&
                this.paymentInformationForm.get('cardNumber').valid &&
                this.paymentInformationForm.get('expirationMonth').valid &&
                this.paymentInformationForm.get('expirationYear').valid) {
                this.isPaymentFormValid = true;
            } else {
                this.isPaymentFormValid = false;
            }
        } else if ((paymentType !== 'VISA' || paymentType !== 'MASTERCARD' || paymentType !== 'DISCOVERNETWORK') && paymentType !== '') {
            if (this.paymentInformationForm.get('fullName').valid &&
                this.paymentInformationForm.get('bankName').valid &&
                this.paymentInformationForm.get('routingNumber').valid &&
                this.paymentInformationForm.get('accountNumber').valid) {
                this.isPaymentFormValid = true;
            } else {
                this.isPaymentFormValid = false;
            }
        }
    }

    setAddress(event): void {
        this.sameAddress = event.target.checked;
        if (this.sameAddress === true && this.paymentInfo) {
            this.paymentInformationForm.controls.billingAddress.setValue(this.paymentInfo.address);
            this.paymentInformationForm.controls.suite_apt.setValue(this.paymentInfo.address2);
            this.paymentInformationForm.controls.billingCity.setValue(this.paymentInfo.city);
            this.paymentInformationForm.controls.billingState.setValue(this.paymentInfo.state);
            this.paymentInformationForm.controls.billingZipCode.setValue(this.paymentInfo.zip);
        } else if (this.sameAddress === false) {
            this.paymentInformationForm.controls.billingAddress.setValue('');
            this.paymentInformationForm.controls.suite_apt.setValue('');
            this.paymentInformationForm.controls.billingCity.setValue('');
            this.paymentInformationForm.controls.billingState.setValue('');
            this.paymentInformationForm.controls.billingZipCode.setValue('');
        }
    }

    async getUserDetails(): Promise<any> {
        const tempData = this.userCacheService.getUserData('tempData');
        let participationId;
        if (this.aboutYou && this.aboutYou.participation_id) {
            participationId = this.aboutYou.participation_id;
        }
        else {
            participationId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
        }
        if (tempData) {
            try {
                this.studentData = JSON.parse(tempData);
            } catch(e) {
                await this.getTempData(participationId);
            }
        } else {
            await this.getTempData(participationId);
        }

        this.getDefaultValues();
        this.getPaymentInfo(participationId);

    }

    getDefaultValues(): void {
        this.configDataService.getConfigData(['payment_types', 'months', 'states_na']).subscribe(data => {
            const obj: any = data;
            if (obj.status === AppConstants.SUCCESS_STATUS) {
                data.configData.forEach(element => {
                    if (element.config_key === 'states_na') {
                        this.statesData = element.json_data;
                    }
                    if (element.config_key === 'payment_types') {
                        console.log('paymentTypes', element.json_data);
                        const sorted = element.json_data.sort((a, b) => a.value.order - b.value.order);
                        const result = sorted.map(item => ({
                            key: item.value.key,
                            value: item.value.text
                        }));
                        console.log('paymentTypes', result);
                        this.paymentTypes = result;
                    }
                    if (element.config_key === 'months') {
                        this.months = element.json_data;
                    }
                });
            }
        }, err => {
            console.log('error occured ');
        });
    }

    getPaymentInfo(id): void {
        let isDependent = false;
        let child = 0;
        let spouse = 0;
        if (this.selectCoverage?.isAdd) {
            isDependent = true;
            this.dependents.dependent.map(data => {
                if (data.type === 'Spouse' || data.type === 'Domestic Partner') {
                    spouse++;
                }
                else if (data.type === 'Child') {
                    child++;
                }
            });
        }
        const paymentInfoObj = {
            participationId: id,
            enrollmentId: this.studentData?.enrollmentId || this.aboutYou?.enrollment_id,
            termId: this.selectCoverage.termId,
            isDependentOnly: isDependent,
            Child: child,
            Spouse: spouse,
            fromDate: this.fromDate,
            toDate: this.toDate,
            isQLE: !!this.aboutYou?.addDepQLE
        };
        this.enrollmentService.getPaymentInfo(paymentInfoObj).subscribe(res => {
            if (res && res.premium) {
                this.paymentInfo = res.premium;
            }
        });
    }

    formatDate(e: any): string {
        if (e && moment(e.toString(), 'MM/DD/YYYY', true).isValid()) {
            return e;
        }
        else if (e) {
            const date = e.toString().split(' ');
            return date.length >= 4 ? moment([date[0], date[1], date[2], date[3]].join(' ')).format('MM/DD/YYYY') : moment(e).format('MM/DD/YYYY');
        }
        else {
            return e;
        }
    }

    async getTempData(participationId): Promise<void> {
        const response: any = await this.detailsService.getStudentInfo(participationId, this.studentData?.enrollmentId || this.aboutYou?.enrollment_id).toPromise();
        if (response.status === AppConstants.SUCCESS_STATUS) {
            this.studentData = response;
            this.userCacheService.setUserData('tempData', JSON.stringify(this.studentData));
        }
    }

    createYearArray(): void {
        let Year = (new Date()).getFullYear();
        for (let i = 0; i < 16; i++) {
            this.currentYear.push(Year++);
        }
    }

    encryptCard(): void {
        if (this.encryptionDownloadError()) {
            // enableSubmit();
            return;
        }
        if (this.keyDownloadError()) {
            // enableSubmit();
            return;
        }
        const result = ProtectPANandCVV(this.paymentInformationForm.value.cardNumber, '', true);
        if (result && result.length > 0) {
            this.cardDetails = {
                ccno: result[0],
                keyId: PIE.key_id,
                phaseId: PIE.phase,
                integrityCheck: result.length > 2 ? result[2] : ''
            };
        }

    }

    encryptionDownloadError(): boolean {
        if (typeof ProtectPANandCVV !== 'function') {
            return true;
        }
        return false;
    }

    keyDownloadError(): boolean {
        if ((typeof (PIE) === 'undefined') || (typeof (PIE.K) === 'undefined') || (typeof (PIE.L) === 'undefined') || (typeof (PIE.E) === 'undefined') || (typeof (PIE.key_id) === 'undefined') || (typeof (PIE.phase) === 'undefined')) {
            return true;
        }
        return false;
    }

    cardNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {
        const paymentType = this.paymentInformationForm?.get('paymentType')?.value;
        const cardNumber = control.value ? control.value.replace(/-/g, '') : '';
        if (!cardNumber || !paymentType) {
            return null;
        }
        if (paymentType === 'DISCOVERNETWORK') {
            const validLengths = [14, 16];
            if (!validLengths.includes(cardNumber.length)) {
                return { invalidCardLength: true };
            }
        } else if (paymentType === 'VISA' || paymentType === 'MASTERCARD') {
            if (cardNumber.length !== 16) {
                return { invalidCardLength: true };
            }
        }
        return null;
    }

    getCardMinLength(): number {
        const paymentType = this.paymentInformationForm.get('paymentType').value;
        if (paymentType === 'DISCOVERNETWORK') {
            return 14;
        }
        return 16;
    }

    getCardMaxLength(): number {
        const paymentType = this.paymentInformationForm.get('paymentType').value;
        if (paymentType === 'DISCOVERNETWORK') {
            return 16;
        }
        return 16;
    }
}
